import { render } from "./AdminNews.vue?vue&type=template&id=28d0e889&scoped=true"
import script from "./AdminNews.vue?vue&type=script&lang=js"
export * from "./AdminNews.vue?vue&type=script&lang=js"

import "./AdminNews.vue?vue&type=style&index=0&id=28d0e889&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d0e889"]])

export default __exports__